import script from "./ProjectAddressForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAddressForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAddressForm.vue?vue&type=style&index=0&id=23f2e6c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f2e6c5"]])

export default __exports__